import '../assets/styles/tabledepositrequest.css';
import Card from "@material-tailwind/react/Card";
import CardHeader from "@material-tailwind/react/CardHeader";
import CardBody from "@material-tailwind/react/CardBody";
import DataTable from "react-data-table-component";
import Button from "@material-tailwind/react/Button";
import axiosInstance from "../config/axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import Select from 'react-select';

export default function TableDepositRequset({ data, pending, acceptEvent, declineEvent, filterBank, perPage, handlePerRowsChange }) {

  const token = localStorage.getItem("access_token");
  const group = JSON.parse(localStorage.getItem("group"));

  const options = [
    { value: 'BCA', label: 'BCA' },
    { value: 'BNI', label: 'BNI' },
    { value: 'BRI', label: 'BRI' },
    { value: 'MANDIRI', label: 'MANDIRI' },
    { value: 'DANAMON', label: 'DANAMON' },
    { value: 'DANA', label: 'DANA' },
    { value: 'OVO', label: 'OVO' },
    { value: 'GOPAY', label: 'GOPAY' },
    { value: 'BANK JAGO', label: 'BANK JAGO' },
    { value: 'LINKAJA', label: 'LINKAJA' },
    { value: 'CIMB NIAGA', label: 'CIMB NIAGA' },
    { value: 'BSI', label: 'BSI' },
    { value: 'QRIS', label: 'QRIS' },
    { value: 'TELKOMSEL', label: 'TELKOMSEL' },
    { value: 'XL', label: 'XL' },
    { value: 'SEABANK', label: 'SEABANK' },
    { value: 'JENIUS', label: 'JENIUS' },
    { value: 'SAKUKU', label: 'SAKUKU' }
  ]

  const accept = (id) => {

    const data = {

      token: token,
      group: group.wbid,
      req_id: id
    }

    Swal.fire({

      title: 'Aceept This Deposit',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      customClass: {
        cancelButton: 'order-confirm-cancel',
        confirmButton: 'order-confirm-ok',
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then(confirm => {

      if (confirm.isConfirmed) {

        const useSifuDepo = process.env.REACT_APP_USE_DEPO_SIFU === 'true';

        let acceptDepoURL = 'deposit_accept'

        if (useSifuDepo) {

          console.log("USE DEPO SIFU");
          acceptDepoURL = 'deposit_accept_sifu';
        }

        axiosInstance.post(acceptDepoURL, data).then((res) => {

          if (res.data.code === 0) {

            Swal.fire('Accepted', 'Deposit Request is Accept', 'success');
            acceptEvent();
          } else if (res.data.code === 101) {

            Swal.fire('Warning', 'Deposit Request Not Fond', 'warning');
            acceptEvent();
          } else if (res.data.code === 102) {

            Swal.fire('Warning', 'Deposit Has Already Processed', 'warning');
            acceptEvent();
          } else if (res.data.code === 103) {

            Swal.fire('Warning', 'Coin not enough, please contact provider', 'warning');
            acceptEvent();
          }else {

            Swal.fire('error', res.data.message, 'warning');
            acceptEvent();
          }
        }).catch((err) => {

          console.log(err);
          Swal.fire('Error', 'Check Your Access And Internet Conection', 'info');
        })
      }
    })
  }

  const decline = (event, id) => {

    const data = {

      token: token,
      group: group.wbid,
      req_id: id
    }

    Swal.fire({

      title: 'Admin note',
      input: 'textarea',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'Decline',
      showLoaderOnConfirm: true,
      preConfirm: (note) => {

        axiosInstance.post('deposit_decline', { admin_note: note, ...data }).then((res) => {

          if (res.data.code == 0) {

            Swal.fire(res.data.message, 'Deposit Request is rejected', 'success');
            declineEvent();
          } else {

            Swal.fire('error', res.data.message, 'warning');
            declineEvent();
          }

        }).catch((err) => {

          console.log(err);
          Swal.fire('Error', 'Check Your Access And Internet Conection', 'info');
        })

        event.preventDefault();
      },

      allowOutsideClick: () => !Swal.isLoading()
    })

  }

  const columns = [
    {
      name: "ID",
      width: "80px",
      selector: (row, index) => row.id,
      sortable: true,
      hide: "md",
    },
    {
      name: "Username",
      selector: (row, index) => row.user,
      grow: "1.5",
    },
    {
      name: "Akun",
      selector: (row) => (
        <div>
          <p>{row.sban + " " + row.snum + " - " + row.snam}</p>
          <p>{row.rban + " " + row.rnum + " - " + row.rnam}</p>
          <p>Note : {row.note}</p>
        </div>
      ),
      width: "280px",
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => <tt style={{fontFamily: "Arial"}} >{row.amou}</tt>,
      sortable: true,
    },
    {
      name: "Current Balance",
      selector: (row) => <tt style={{fontFamily: "Arial"}}>{row.cbal}</tt>,
      sortable: true,
      right: true,
      hide: "md",
      width: '150px'
    },
    {
      name: "Request Date",
      selector: (row) => row.rdat,
      sortable: true,
      width: '220px',
      hide: "md",
    },
    {
      name: "",
      selector: (row) => (
        <Button
          color="green"
          buttonType="filled"
          size="sm"
          rounded={false}
          block={false}
          iconOnly={false}
          ripple="light"
          onClick={() => {

            accept(row.id)
          }}
        >
          Accept
        </Button>
      ),
      compact:"true",
    },
    {
      name: "",
      selector: (row) => (
        <Button
          color="deepOrange"
          buttonType="filled"
          size="sm"
          rounded={false}
          block={false}
          iconOnly={false}
          ripple="light"
          onClick={(event) => {
            decline(event, row.id)
          }}
        >
          Decline
        </Button>
      ),
      compact:"true",
    },
  ];

          
  return (
    <Card>
      <CardHeader color="blueGray" contentPosition="left" className="">
        <h2 className="text-white text-2xl">Deposit Request</h2>
      </CardHeader>
      <CardBody className="">
        <div className="flex flex-col">
          <div>
            <Link to="/money_management/create_deposit_request">
                <Button
                  color="lightBlue"
                  buttonType="filled"
                  size="regular"
                  rounded={false}
                  block={false}
                  iconOnly={false}
                  ripple="light"
                  className="w-full mb-3"
                >
                  Manual Deposit
                </Button>
              </Link>
          </div>
          <div>
            <Select
                options={options}
                onChange={(choice) => {

                  filterBank(choice.value)
                }} />
          </div>
        </div>

        <DataTable
          columns={columns}
          data={data}
          progressPending={pending}
          onChangeRowsPerPage={handlePerRowsChange}
          paginationPerPage={perPage}
          paginationRowsPerPageOptions={[20, 50, 100, 500]}
          pagination
        />
      </CardBody>
    </Card>
  );
}
